import * as React from "react";
import { CorrectionItem } from "../CorrectionItem";

/**
 * This is the entry in the list of DCFs that will be available to the user.
 */
export const SubjectIdItem = ({ recordId, isDisabled, onClick, onRemove, correctionSelected, subjectDisplayText }): JSX.Element => {
    return (
        <CorrectionItem
                recordId={recordId}
                title={`Change ${subjectDisplayText}`}
            description={`Change the ${subjectDisplayText} for a single Participant.`}
                isDisabled={isDisabled}
                onClick={onClick}
                onRemove={onRemove}
                correctionSelected={correctionSelected}
            />
    );
}
